module.exports = __webpack_public_path__ + "static/media/gryphon-house-angle-view.a3ab606f.jpg";